<div class="flex flex-col gap-2">
  <div class="flex flex-col gap-8 pb-3">
    <div class="grid grid-cols-3 gap-4 pt-2 transition-all duration-300">
      <div class="group relative">
        <label
          i18n="@@hasSubproduct"
          for="hasSubproductFilter"
          class="absolute -top-2 z-10 border border-none bg-white px-1 text-[12px] font-semibold text-gray-700 ltr:left-3 rtl:right-3">
          Has Sub Products
        </label>
        <div class="">
          <select
            [ngModel]="hasSubProducts()"
            (ngModelChange)="onHasSubProductsChange($event)"
            id="hasSubproductFilter"
            class="globalSelect w-full rounded-[10px] border border-gray-400 bg-white px-4 py-2.5 text-[14px] outline-none"
            [class.selectAr]="isArabic()"
            [class.selectEn]="isEnglish()">
            <option value="" i18n="@@all">All (default)</option>
            <option value="true" i18n="@@yes">YES</option>
            <option value="false" i18n="@@no">NO</option>
          </select>
        </div>
      </div>

      <div class="group relative">
        <label
          i18n="@@productNameSearch"
          for="productTitle"
          class="absolute -top-2 z-10 bg-white px-1 text-[12px] font-semibold text-gray-700 ltr:left-3 rtl:right-3">
          Product Name
        </label>
        <div class="relative">
          <input
            type="text"
            id="productTitle"
            [(ngModel)]="filters().productTitle"
            (ngModelChange)="onChangeTitle($event)"
            (focus)="onProductTitleFocus()"
            class="w-full rounded-[10px] border border-gray-400 bg-white py-2.5 text-[14px] outline-none ltr:pl-10 rtl:pr-10"
            placeholder="Search products by name..."
            i18n-placeholder="@@productNameSearchPlaceholder" />
          <svg
            class="absolute top-1/2 h-5 w-5 -translate-y-1/2 text-gray-400 ltr:left-3 rtl:right-3"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor">
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
          </svg>

          @if (showProductTitleDropdown()) {
            <div
              class="absolute z-20 mt-1 max-h-52 w-full overflow-y-auto rounded-lg border border-gray-200 bg-white shadow-xl">
              @if (productTitleLoading()) {
                <div class="px-3 py-2 text-[13px] text-gray-500" i18n="@@productNameSearching">Searching...</div>
              } @else if (productTitleResults().length === 0) {
                <div class="px-3 py-2 text-[13px] text-gray-500" i18n="@@productNameNotFound">No products found.</div>
              } @else {
                @for (item of productTitleResults(); track item.id) {
                  <button
                    (click)="onSelectProductTitle(item)"
                    [class]="isArabic() ? 'text-right' : 'text-left'"
                    class="block w-full px-4 py-2 text-left text-[14px] hover:bg-gray-50">
                    {{ isArabic() ? item.titleAr || item.titleEn : item.titleEn }}
                  </button>
                }
              }
            </div>
          }
        </div>
      </div>

      <div class="group relative">
        <label
          i18n="@@adminMFGCompany"
          class="absolute -top-2 z-10 bg-white px-1 text-[12px] font-semibold text-gray-700 ltr:left-3 rtl:right-3">
          MFG Company
        </label>
        <select
          [(ngModel)]="filters().mfgCompanyId"
          class="globalSelect w-full appearance-none rounded-[10px] border border-gray-400 bg-white px-4 py-2.5 text-[14px] outline-none hover:cursor-pointer"
          [class.selectAr]="isArabic()"
          [class.selectEn]="isEnglish()">
          <option disabled i18n="@@adminSelectCompaniesPlaceholder">Select company...</option>
          <option [ngValue]="undefined" i18n="@@adminAllCompaniesPlaceholder">All Companies</option>
          @for (company of mfgCompanies(); track company.id) {
            <option [ngValue]="company.id">{{ company.titleEn }}</option>
          }
        </select>
      </div>
    </div>

    <!-- CATEGORY ROW -->
    <div class="grid grid-cols-2 gap-4 transition-all duration-300">
      <!-- CATEGORY -->
      <div class="group relative">
        <label
          i18n="@@categoriesSectionTitle"
          for="categories"
          class="absolute -top-2 z-10 border border-none bg-white px-1 text-[12px] font-semibold text-gray-700 ltr:left-3 rtl:right-3">
          Category
        </label>
        <div class="">
          <select
            [(ngModel)]="filters().categoryId"
            (ngModelChange)="onCategoryChangeFn($event)"
            id="categories"
            class="globalSelect w-full rounded-[10px] border border-gray-400 bg-white py-2.5 text-[14px] outline-none ltr:pl-10 rtl:pr-10"
            [class.selectAr]="isArabic()"
            [class.selectEn]="isEnglish()">
            <option value="" disabled i18n="@@adminProductFormSelectCategory">Select Category</option>
            @for (item of categories(); track item.id) {
              <option [ngValue]="item.id">{{ isArabic() ? item.titleAr : item.titleEn }}</option>
            }
          </select>
        </div>
      </div>

      <!-- SUBCATEGORY -->
      <div class="group relative">
        <label
          i18n="@@subcategoriesSectionTitle"
          for="subcategories"
          class="absolute -top-2 z-10 border border-none bg-white px-1 text-[12px] font-semibold text-gray-700 ltr:left-3 rtl:right-3">
          Subcategories
        </label>
        <div class="">
          <select
            [(ngModel)]="filters().subCategoryId"
            id="subcategories"
            class="globalSelect w-full rounded-[10px] border border-gray-400 bg-white py-2.5 text-[14px] outline-none ltr:pl-10 rtl:pr-10"
            [class.selectAr]="isArabic()"
            [class.selectEn]="isEnglish()">
            <option value="" disabled i18n="@@adminProductFormSelectSubcategory">Select Subcategory</option>
            @for (item of subCategories()?.list; track item.id) {
              <option [ngValue]="item.id">{{ isArabic() ? item.titleAr : item.titleEn }}</option>
            }
          </select>
        </div>
      </div>
    </div>

    <!-- CREATED & STATUS ROW -->

    <div class="grid grid-cols-3 gap-4 transition-all duration-300">
      <!-- CREATED FROM -->
      <div class="group relative">
        <label
          i18n="@@createdOnFrom"
          for="createdOnFrom"
          class="absolute -top-2 z-10 border border-none bg-white px-1 text-[12px] font-semibold text-gray-700 ltr:left-3 rtl:right-3">
          Created On – From
        </label>
        <div class="">
          <input
            type="date"
            [(ngModel)]="filters().createdOnFrom"
            id="createdOnFrom"
            (change)="validateDateRange()"
            class="w-full rounded-[10px] border border-gray-400 bg-white px-4 py-2.5 text-[14px] outline-none" />
        </div>
      </div>

      <!-- CREATED ON TO -->
      <div class="group relative">
        <label
          i18n="@@createdOnTo"
          for="createdOnTo"
          class="absolute -top-2 z-10 border border-none bg-white px-1 text-[12px] font-semibold text-gray-700 ltr:left-3 rtl:right-3">
          Created On – To
        </label>
        <div class="">
          <input
            type="date"
            [(ngModel)]="filters().createdOnTo"
            (change)="validateDateRange()"
            id="createdOnTo"
            class="w-full rounded-[10px] border border-gray-400 bg-white px-4 py-2.5 text-[14px] outline-none" />
        </div>
        @if (dateRangeError()) {
          <p class="mt-1 text-[11px] text-red-500" i18n="@@dateRangeError">From date cannot be after To date</p>
        }
      </div>

      <!-- STATUS -->

      <div class="group relative">
        <label
          i18n="@@status"
          class="absolute -top-2 z-10 bg-white px-1 text-[12px] font-semibold text-gray-700 ltr:left-3 rtl:right-3">
          Status
        </label>
        <select
          type="date"
          [(ngModel)]="filters().status"
          class="globalSelect w-full rounded-[10px] border border-gray-400 bg-white px-4 py-2 text-[14px] outline-none"
          [class.selectAr]="isArabic()"
          [class.selectEn]="isEnglish()">
          <option value="" i18n="@@all">All</option>
          <option value="active" i18n="@@activated">Activated</option>
          <option value="inactive" i18n="@@deactivated">Deactivated</option>
        </select>
      </div>
    </div>
    <div class="section-border flex items-end justify-between border-t pt-4">
      <div class="grid w-[70%] grid-cols-3 gap-6">
        <div class="group relative">
          <label
            i18n="@@productsSortBy"
            class="absolute -top-2 z-10 bg-white px-1 text-[12px] font-semibold text-gray-700 ltr:left-3 rtl:right-3">
            Sort By
          </label>

          <div class="flex gap-2">
            <select
              [(ngModel)]="filters().orderBy"
              class="globalSelect w-full appearance-none rounded-[10px] border border-gray-400 bg-white px-4 py-2 text-[14px] outline-none"
              [class.selectAr]="isArabic()"
              [class.selectEn]="isEnglish()">
              <option value="LAST_MODIFICATION_DATE" i18n="@@productsSortByLastModified">Last Modified</option>
              <option value="CREATION_DATE" i18n="@@productsSortByCreationDate">Creation Date</option>
              <option value="TITLE" i18n="@@productNameSearch">Product Title</option>
            </select>

            <button
              (click)="onToggleSortOrder()"
              class="w-[150px] rounded-[10px] border border-gray-400 bg-white px-2.5 py-2.5 text-[14px] font-[500] text-gray-700 transition-colors hover:cursor-pointer hover:border-gray-600 hover:bg-gray-50 focus:border-black focus:outline-none">
              @if (filters().orderDir === "ASC") {
                <span i18n="@@DESC">DESC</span>
              } @else {
                <span i18n="@@ASC">ASC</span>
              }
            </button>
          </div>
        </div>
      </div>

      <div class="flex gap-3">
        <button
          i18n="@@productsReset"
          (click)="onResetFilters()"
          class="border-primary text-primary hover-bg-primary-10 cursor-pointer rounded-[6px] border px-6 py-2 text-[13px] font-bold">
          Clear
        </button>
        <button
          i18n="@@productsApply"
          (click)="onApplyFilters()"
          class="bg-primary hover-bg-primary-hover cursor-pointer rounded-[6px] px-6 py-2 text-[13px] font-bold text-white">
          Apply
        </button>
      </div>
    </div>
  </div>
</div>
